//@ts-nocheck
import React, {Suspense} from 'react'
import {BrowserRouter} from 'react-router-dom'
import FrontendTracer from 'telemetry/FrontendTracer'
import {LayoutProvider, LayoutSplashScreen} from '../_metronic/layout/core'
import AuthInit from './features/auth/redux/AuthInit'
import {AppRoutes} from './routing/AppRoutes'
import './validator'
import OrderApp from 'corksyOrders/OrderApp'

FrontendTracer()

type Props = {
  basename: string
}

const App: React.FC<Props> = ({basename}) => {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <BrowserRouter basename={basename} getUserConfirmation={() => {}}>
        <LayoutProvider>
          <AuthInit>
            <OrderApp />
            <AppRoutes />
          </AuthInit>
        </LayoutProvider>
      </BrowserRouter>
    </Suspense>
  )
}

export {App}
